.aboutContent {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  margin-bottom: 20px;
}
.aboutContent .appIcon {
  width: 96px;
  height: 96px;
  border-radius: 22%;
  margin-bottom: 15px;
}
.aboutContent .appVersion {
  margin-bottom: 15px;
}
.aboutContent .appVersion .commitMessageHint {
  cursor: help;
  opacity: 0.7;
}